import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";

const SwitchPausarAtendimento = ({ onUpdateStatus, data }) => {
  const [status, setStatus] = useState(!!data.atendimento_pausado);

  const handleToggle = () => {
    const newStatus = !status;
    setStatus(newStatus);
    onUpdateStatus(newStatus); // notifica o backend
  };

  const IOSSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#ff9900", // laranja quando pausado
          opacity: 1,
          border: 0,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#0fd826", // verde quando disponível
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  return (
    <FormControlLabel
      control={
        <IOSSwitch
          sx={{ m: 1 }}
          checked={status}
          onChange={handleToggle}
        />
      }
      label={
        status ? (
          <div>
            <strong style={{ color: "#ff9900" }}>Atendimento pausado</strong>
          </div>
        ) : (
          <div>
            <strong style={{ color: "#0fd826" }}>Atendimento disponível</strong>
          </div>
        )
      }
    />
  );
};

export default SwitchPausarAtendimento;
